import { render, staticRenderFns } from "./PannelloControllo.vue?vue&type=template&id=60ea7fa0&scoped=true&"
var script = {}
import style0 from "./PannelloControllo.vue?vue&type=style&index=0&id=60ea7fa0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea7fa0",
  null
  
)

component.options.__file = "PannelloControllo.vue"
export default component.exports